import { render } from "./PackageEditor.vue?vue&type=template&id=0a807e20"
import script from "./PackageEditor.vue?vue&type=script&lang=js"
export * from "./PackageEditor.vue?vue&type=script&lang=js"

import exportComponent from "/home/mike/VueCode/service-package-editor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__